import React, { useEffect } from "react";
import Privacy from "../components/Privacy/privacy";
import Footer from "../components/Footer/footer";
import Navbar from "../components/Navbar/navbar";

const Privacypage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <Privacy />
      <Footer />
    </div>
  );
};

export default Privacypage;
